var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"m-auto",attrs:{"width":"95%"}},[_c('v-data-table',{attrs:{"fixed-header":"","headers":_vm.headers,"items":_vm.getTxnNoteDetails,"hide-default-footer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }